module.exports = __webpack_public_path__ + "static/media/dinero.280fff47.png";